/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Kit 2 React components

// Material Kit 2 React examples
import DefaultNavbar from "views/Navbars/DefaultNavbar";
import DefaultFooter from "views/Footers/DefaultFooter";

// Routes

// eslint-disable-next-line import/no-cycle
import routes from "routes";

import footerRoutes from "footer.routes";
import Grid2 from "@mui/material/Unstable_Grid2";
import MKTypography from "../../components/MKTypography";
import MKBox from "../../components/MKBox";

// Images
import bgImage from "../../assets/images/backgrounds/111.jpg";
import KeyElements from "./sections/KeyElements";
import Countries from "./sections/Countries";
import SectionCard from "./components/SectionCard";
import Assessments from "./sections/Assessments";
import Analysis from "./sections/Analysis";

function Home() {
  return (
    <>
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        height="55vh"
        width="100%"
        sx={{
          alignItems: "center",
          backgroundImage: ({ palette: { dark, black }, functions: { linearGradient, rgba } }) =>
            `${linearGradient(rgba(dark.main, 0.2), rgba(black.main, 0.6))}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <MKBox
          mx={{ sm: 3, xl: 12, xxl: 24, xxxl: 36, xxxxl: 72 }}
          justifyContent={{ lg: "left", sm: "center" }}
        >
          <Grid2 container>
            <Grid2 xs={12} lg={7} xxl={6} xxxl={5}>
              <MKTypography variant="h2" color="white" textAlign="left" mt={6}>
                Hindu Kush Himalayan Sustainable Development Monitoring and Assessment
              </MKTypography>
              <MKTypography
                variant="body1"
                color="white"
                textAlign="justify"
                mt={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  lineHeight: 1.3,
                  [breakpoints.up("xl")]: {
                    fontSize: size.xl,
                  },
                  //   fontszie is depended by breakboints (from browser screen width)
                })}
              >
                Hindu Kush Himalayan (HKH), the &quot;pulse of the Earth&quot;, spans eight
                countries from west to east and is rich in water, forest, grass and agriculture.
                This system provides query, access, acquisition, online calculation and analysis
                services for sustainable development assessment of water resources, agriculture,
                environment.
              </MKTypography>
            </Grid2>
          </Grid2>
        </MKBox>
      </MKBox>
      <MKBox mx={{ sm: 3, xl: 12, xxl: 24, xxxl: 36, xxxxl: 72 }} justifyContent="center">
        {/* Assessments section in home page */}
        <SectionCard
          title="Sustainable Development Assessment in the HKH"
          description="The sustainable development evaluation models of agriculture, water resources, forest and grass are established respectively, and a total of 6 indicators are formed to evaluate the sustainable development ability of the geographical elements in the study area."
        >
          <Assessments />
        </SectionCard>
        {/* KeyElements section in home page */}
        <SectionCard
          title="SDG Datasets"
          description={
            "Remote sensing inversion models of key elements of water resources, agricultural\n" +
            "              conditions and ecological environment in HKH region were developed, and inversion data\n" +
            "              of six key elements were generated."
          }
        >
          <KeyElements />
        </SectionCard>
        {/* Analysis section in home page */}
        <SectionCard
          title="Spatio-Temporal Visual Analysis  "
          description="A total of 12 analysis indicators were generated based on the data of key elements, reflecting the temporal changes and spatial distribution of key elements in different aspects in the form of tile maps and statistical charts."
        >
          <Analysis />
        </SectionCard>
        {/* Countries section in home page, click flag will navigate to assessment page */}
        <SectionCard
          title="Country-Focused SDG Data in the HKH"
          description="The Hindu Kush Himalayan region covers eight countries, including Afghanistan, Bangladesh, Bhutan, China, India, Myanmar, Nepal and Pakistan. The area of the HKH region occupied by each country and the geographical features within it vary."
        >
          <Countries />
        </SectionCard>
      </MKBox>
      <DefaultFooter content={footerRoutes} />
    </>
  );
}

export default Home;
